export const getEcomSubscriptionLabel = t => {
  return {
    nodes: [{
      paragraphData: {
        textStyle: {
          textAlignment: 'AUTO'
        }
      },
      type: 'PARAGRAPH',
      nodes: [{
        type: 'TEXT',
        nodes: [],
        textData: {
          text: t('ecom.form.field-type.ecom-subscriptions.label'),
          decorations: []
        },
        id: ''
      }],
      id: '8k8yy2'
    }]
  };
};
//# sourceMappingURL=get-label.js.map